import { makeStyles, createStyles, Theme } from '@material-ui/core/styles';

export const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    checklistMargin: {
        margin: '5px 2px'
    },
    smFont: {
        fontSize: '14px'
    },
    valid: {
        color: '#4BCA81'
    },
    invalid: {
        color: '#FF0033'
    },
    progressContainer: {
        display: 'flex',
        alignItems: 'center',
        marginBottom: '4px'
    },
    progressBar: {
        flexGrow: 1,
        marginLeft: '8px'
    },
    passwordStrength: {
        marginTop: '8px',
        marginBottom: '4px',
        fontWeight: 'bold'
    },
    strengthText: {
        fontSize: '14px',
        fontWeight: 'bold'
    }
  })
);
